 

export default {
    buildMsg: function (title, text, type) {

        var msg = "";
        if (type == "success") {
            msg = "<div class='popup-title'>" + title + "</div> <div class='material-icons popup-icon'>check_circle_outline</div> ";
        } else if (type == 'error') {
            msg = "<div class='popup-title'>" + title + "</div> <div class='material-icons popup-icon-error'>cancel</div> ";
        } else {
            msg = "<div class='popup-title'>" + title + "</div>";
        }

        msg += text + "<br />";

        return msg;
    },

    alert: function (context, title, text, type) {
 
        var msg = "";
        if (type == "success") {
            msg = "<div class='popup-title'>" + title + "</div> <div class='material-icons popup-icon'>check_circle_outline</div> ";           
        } else if (type == 'error') {
            msg = "<div class='popup-title'>" + title + "</div> <div class='material-icons popup-icon-error'>cancel</div> ";
        } else {
            msg = "<div class='popup-title'>" + title + "</div>";
        }

        msg += text;
 
        var promise = new Promise(resolve => {
            resolve(context.$alert(msg, title));
        });

        return promise;
         
    },
    confirm: function (context, title, text, type) {


        var msg = "";
        if (type == 'question') {
            msg = "<div class='popup-title'>"+title+"</div> <div class='material-icons popup-icon'>help_outline</div> ";
        } else {
            msg = "<div class='popup-title'>" + title + "</div>";
        }

        msg += text;

        var promise = new Promise(resolve => {
            resolve(context.$confirm(msg, title));
        });

        return promise;
          
    }

}